import {
  GetBlacklistedCustomersQuery,
  GetCustomerReferralQuery,
} from "@/api/hasura/generated/graphql"
import {
  CustomerReferralCode,
  IReferralCode,
} from "@/models/operations/referralCode/referralCode.types"
import { ReferralCode } from "@/models/operations/referralCode/referralCode"
import dayjs from "dayjs"

export const parseCustomerReferralCodeQuery = (
  data?: GetCustomerReferralQuery,
): IReferralCode | null => {
  if (!data?.customer_referrals?.[0]?.referee.customer_user_rels?.[0]) {
    return null
  }

  return parseReferralCodesQuery(
    data?.customer_referrals[0].referee.customer_user_rels[0]
      .customer as unknown as CustomerReferralCode,
  )
}

const parseReferralCodesQuery = (
  customer?: CustomerReferralCode,
): IReferralCode | null => {
  if (!customer || !customer.customer_referrals.length) {
    return null
  }

  return new ReferralCode(
    customer.number,
    customer.billing_accounts.length ? customer.billing_accounts[0].number : "",
    customer.customer_user_rels[0]?.user_id,
    customer.customer_user_rels.find((rel) => rel.user?.email)?.user?.email ??
      "",
    customer.customer_referrals.length
      ? dayjs(customer.customer_referrals[0].created_at)
      : undefined,
  )
}

export const parseReferralCode = (
  data: GetBlacklistedCustomersQuery["customer"][number],
) =>
  new ReferralCode(
    data.number,
    data.billing_accounts.length ? data.billing_accounts[0].number : "",
    data.customer_user_rels[0]?.user_id,
    data.customer_user_rels.find((rel) => rel.user?.email)?.user?.email ?? "",
    data.customer_referrals.length
      ? dayjs(data.customer_referrals[0].created_at)
      : undefined,
  )
